import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class MarkAllNotificationsReadUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string): Promise<void> {
    logger.debug('MarkAllNotificationsRead', 'Marking all as read', { userId });
    await this.notificationRepository.markAllAsRead(userId);
  }
}
